module.exports = __webpack_public_path__ + "img/telegram_white.e6818745.svg";